// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".suucB {\n  position: fixed !important;\n  bottom: var(--spacing-xt-sm);\n  right: 108px;\n  opacity: 0.7;\n}\n\n.suucB:hover {\n  opacity: 1;\n}\n\n.xupQi {\n  fill: var(--white);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpButton": "suucB",
	"help": "xupQi"
};
export default ___CSS_LOADER_EXPORT___;
